import React, { PropsWithChildren } from "react";
import { Config } from "../../config";
import { ADGroupFromPermission, Permission, useAuth } from "../../hooks";
import { AccessRestrictedAlert } from "./access-restricted-alert";

type AccessControlProps = {
  permissions: Permission | Permission[];
  hideAlert?: boolean;
};

export const AccessControl = ({
  permissions,
  hideAlert,
  children,
}: PropsWithChildren<AccessControlProps>) => {
  const { currentUser } = useAuth();

  const hasPermission = currentUser?.hasAnyOf(permissions) || false;
  return hasPermission ? (
    <>{children}</>
  ) : hideAlert ? null : (
    <AccessRestrictedAlert
      description={
        <Description isAdUser={currentUser?.isAdUser ?? false} permissions={permissions} />
      }
    />
  );
};

type DescriptionProps = {
  permissions: Permission | Permission[];
  isAdUser: boolean;
};
const Description: React.FC<DescriptionProps> = ({ permissions, isAdUser }) => {
  const requiredGroups = ADGroupFromPermission(permissions);
  return (
    <div>
      <p>Sorry! You do not have permission to access this section.</p>
      {isAdUser && (
        <div>
          <p>
            You need to be a member of <b>{requiredGroups.join(", ")}</b> Active Directory Group
            {`${requiredGroups.length > 1 ? "s" : ""}`}
          </p>
          <p>Please contact your IT Department.</p>
          <a
            title={"Click here to learn more"}
            target={"_blank"}
            rel={"noopener noreferrer"}
            href={Config.Links.SupportArticles.AD_Groups_Help ?? ""}
          >
            Click here to learn more
          </a>
        </div>
      )}
    </div>
  );
};
